import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const AuthCustomActions = importer('Stores/AuthCustom/Actions')
export default function * success ({ res }) {
  const { sessionToken } = res
  yield put(AuthCustomActions.loginAuth({ sessionToken }))
}
